import { TBuilderPromoBanner } from '../types';

export const BUILDER_LANDING_PROMO_TYPE: { [key: number]: TBuilderPromoBanner } = {
  0: 'banner1',
  1: 'banner2',
  2: 'section',
};
